
import React, { useState } from 'react';
import ResourcePageLayout from '@/components/layouts/ResourcePageLayout';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search as SearchIcon } from 'lucide-react';

const Search = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Search implementation would go here
    console.log('Searching for:', searchQuery);
  };
  
  return (
    <ResourcePageLayout 
      title="Search" 
      description="Find articles, FAQs, resources, and more across Hormone Balance Guide."
    >
      <form onSubmit={handleSearch} className="mb-8">
        <div className="flex gap-2 mb-4">
          <Input
            type="text"
            placeholder="Type to search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 focus:border-hormony-coral focus:ring-hormony-coral"
          />
          <Button type="submit" variant="coral">
            <SearchIcon size={20} />
            <span>Search</span>
          </Button>
        </div>
      </form>
      
      <div className="p-6 bg-white rounded-lg border border-hormony-beige/50 text-center">
        <p className="text-hormony-charcoal/70">
          Enter a search term above to find content across our site
        </p>
      </div>
    </ResourcePageLayout>
  );
};

export default Search;
